import { postRequest } from '../clients/axios';
import { TourBagMstrPayload } from '../models';

interface IPostSaveTourBagMstrEntityProps {
  tourBagMstrData: TourBagMstrPayload;
  lastSyncDate: string;
  forceUpdate?: boolean;
}

export const postSaveTourBagMstrEntity = async ({ tourBagMstrData, lastSyncDate, forceUpdate = false }: IPostSaveTourBagMstrEntityProps) => {
  const url = `tourBag/SaveTourBagMstrEntity?forceUpdate=${forceUpdate}&pwaLastSync=${lastSyncDate}`;
  const response = await postRequest(url, tourBagMstrData);
  return response;
};
